export default __webpack_public_path__ + "static/media/lion-mrs-rasta.1e602132.jpg";